var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGiggly = function SvgGiggly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.25 12a8.749 8.749 0 1 0 17.498 0A8.749 8.749 0 0 0 3.25 12m1.5 0c0-1.922.764-3.767 2.123-5.127a7.254 7.254 0 0 1 10.255 0 7.254 7.254 0 0 1 0 10.255 7.254 7.254 0 0 1-10.255 0A7.25 7.25 0 0 1 4.75 12",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.473 12.85a1.29 1.29 0 0 0-1.048.542 1.28 1.28 0 0 0-.162 1.169 6.083 6.083 0 0 0 11.474 0 1.3 1.3 0 0 0-.163-1.17 1.28 1.28 0 0 0-1.047-.541zm8.736 1.5H7.79a4.585 4.585 0 0 0 8.42 0zm1.115-3.667a2.35 2.35 0 0 0-4.431 0 .75.75 0 0 0 1.414.5.852.852 0 0 1 1.292-.411.85.85 0 0 1 .31.41.751.751 0 0 0 1.415-.5zm-6.217.001a2.349 2.349 0 0 0-4.431 0 .75.75 0 0 0 1.414.499.852.852 0 0 1 1.293-.411.86.86 0 0 1 .31.41.75.75 0 1 0 1.414-.499z",
    clipRule: "evenodd"
  })));
};
export default SvgGiggly;